module.exports = __webpack_public_path__ + "img/img-cathay-footer.2b243f65.svg";